import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { JudgeDetail } from '@/domain/entities/judge/judgeDetail'
import { JudgeDetailModuleName } from '@/store/modules/modules'

export class JudgeDetailViewModel {
  private store = useStore()

  judgeDetail: ComputedRef<JudgeDetail | null> = computed(
    () => this.store.getters[`${JudgeDetailModuleName}/judgeDetail`]
  )
  testJudgeDetail: ComputedRef<JudgeDetail | null> = computed(
    () => this.store.getters[`${JudgeDetailModuleName}/testJudgeDetail`]
  )

  removeJudgeDetails(): void {
    this.store.commit(`${JudgeDetailModuleName}/setJudgeDetail`, null)
    this.store.commit(`${JudgeDetailModuleName}/setTestJudgeDetail`, null)
  }
}
